package dev.lingvo.site.pages.app.settings.agents

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import dev.lingvo.shared.AgentAutonomy
import dev.lingvo.shared.AgentConnectionDto
import dev.lingvo.shared.TokenScope
import dev.lingvo.site.pages.app.settings.rememberWorkspaceAuthorityState
import dev.lingvo.site.state.WorkspaceRequestContext

internal class NewAgentPageState {
    var name by mutableStateOf("")
    var preset by mutableStateOf(AgentPreset.READ_ONLY)
    var scopes by mutableStateOf(AgentPreset.READ_ONLY.scopes)
    var expiresInDays by mutableStateOf("30")
    var autonomy by mutableStateOf(AgentAutonomy.PROPOSE)
    var projects by mutableStateOf("")
    var monthly by mutableStateOf("0")
    var daily by mutableStateOf("0")
    var perCall by mutableStateOf("0")
    var busy by mutableStateOf(false)
    var message by mutableStateOf<String?>(null)
    var created by mutableStateOf<AgentConnectionDto?>(null)
    var copied by mutableStateOf(false)
    var pendingNav by mutableStateOf<String?>(null)
}

@Composable
internal fun rememberNewAgentPageState(context: WorkspaceRequestContext?): NewAgentPageState =
    rememberWorkspaceAuthorityState(context) { NewAgentPageState() }

internal class AgentDetailPageState {
    var refreshKey by mutableStateOf(0)
    var busy by mutableStateOf(false)
    var message by mutableStateOf<String?>(null)
    var rotated by mutableStateOf<String?>(null)

    /**
     * Whether the reader has copied the rotated credential.
     *
     * The button said "Copy token" before the press and "Copy token" after it, so the only evidence
     * a copy had happened was the clipboard — on the one screen where the value is shown once and
     * the next action dismisses it for good. `agents/New.kt` has always toggled its label; this page
     * had no state to toggle with.
     */
    var copied by mutableStateOf(false)
    var confirmingRevoke by mutableStateOf(false)
    var editingBudget by mutableStateOf(false)
    var monthly by mutableStateOf("0")
    var daily by mutableStateOf("0")
    var perCall by mutableStateOf("0")
}

@Composable
internal fun rememberAgentDetailPageState(
    context: WorkspaceRequestContext?,
    agentId: String,
): AgentDetailPageState = rememberWorkspaceAuthorityState(context, agentId) { AgentDetailPageState() }
